import { mergeLists } from '@/lib/apollo/mergeLists';

function offsetFromVariables(variables: unknown): number | null | undefined {
  if (!variables || typeof variables !== 'object') return undefined;
  if (!('offset' in variables)) return undefined;
  const offset = (variables as { offset?: number | null }).offset;
  return offset;
}

/**
 * `updateQuery` for Apollo `fetchMore` on `no-cache` watch queries.
 * Apollo 3.11.3+ throws if fetchMore is called without this, because
 * field-policy merge functions never run when nothing is written to cache.
 */
export function appendFetchMoreList<TField extends string>(field: TField) {
  return <TData extends Record<TField, unknown[] | null | undefined>>(
    previous: TData,
    {
      fetchMoreResult,
      variables,
    }: {
      fetchMoreResult?: TData;
      variables?: unknown;
    },
  ): TData => {
    if (!fetchMoreResult) return previous;
    const incoming = fetchMoreResult[field];
    if (!Array.isArray(incoming)) return previous;
    const existing = previous[field];
    return {
      ...previous,
      ...fetchMoreResult,
      [field]: mergeLists(
        Array.isArray(existing) ? existing : [],
        incoming,
        { args: { offset: offsetFromVariables(variables) } },
      ),
    };
  };
}
